// src/pages/Auth/ResetPassword/useResetPassword.js
import useAuthForm from "../../../hooks/useAuthForm";
import { resetPassword } from "../../../services/authService";
import validateByType from '../../../hooks/useFormValidation';


const useResetPassword = () => {
  const initialValues = {
    password: '',
    password_confirmation: '',
  };

  return useAuthForm({
    initialValues,
    validateFn: (form) => validateByType('resetPassword', form),
    submitFn: resetPassword,
    onSuccessNavigateTo: '/dashboard',  
    successMessageText: 'Password reset successful'
  });
};

export default useResetPassword;
